import { Column } from 'primereact/column';

import { LuEye, LuFileEdit, LuTrash2 } from 'react-icons/lu';

import { BasicSelectComponent } from '../../../components/BasicSelectComponentComponent';
import { validatePermissions } from '../../../utils/utils';
import { ButtonComponent } from './../../../components/ButtonComponen';
import { TableComponent } from './../../../components/Table';
import {
  CatalogType,
  ITableCatalogProps,
} from './../../../interfaces/interfaceCatalogs';
import { PermitsList } from './../../../permitsList';
import { InputText } from 'primereact/inputtext';

export const TableCatalogComponent = (props: ITableCatalogProps) => {
  const { serviceCatalog } = props;

  const renderTitle = () => {
    return (
      <div className="flex justify-between w-full h-auto pb-2">
        <span className="text-3xl font-medium">
          {serviceCatalog.tableTitle}
        </span>
        <div className="flex h-12 items-center text-xl cursor-pointer">
          {validatePermissions(PermitsList.CATALOGS_ADD) &&
          serviceCatalog.catalog !== CatalogType.SamTypes &&
          serviceCatalog.catalog !== CatalogType.CardMapping ? (
            <ButtonComponent
              label={'Agregar'}
              className="w-auto h-12 bg-white border-solid border border-alternative_green text-alternative_green hover:bg-alternative_green"
              onClick={() => {
                serviceCatalog.openTableRightMenu();
              }}
              iconPos="left"
              icon="pi pi-plus"
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  };

  const renderFileUploadLabel = () => {
    return (
      <label
        htmlFor="file"
        className="w-1/4 h-12 flex cursor-pointer justify-center items-center bg-white border-solid border border-alternative_green text-alternative_green hover:bg-alternative_green rounded text-center hover:text-white">
        <span className="cursor-pointer">
          {serviceCatalog.file === null
            ? 'Subir archivo (.xlsx)'
            : 'Archivo cargado'}
        </span>
      </label>
    );
  };

  const renderImportButton = () => {
    if (serviceCatalog.file !== null) {
      return (
        <ButtonComponent
          label={'Importar'}
          className="w-1/4 h-12 bg-white border-solid border border-alternative_green text-alternative_green hover:bg-alternative_green "
          severity="success"
          outlined={true}
          type="submit"
        />
      );
    }
    return null;
  };

  const renderFilters = () => {
    if (serviceCatalog.catalog === CatalogType.SamTypes) {
      return (
        <div className="">
          <BasicSelectComponent
            classNames="h-12"
            options={serviceCatalog.samKeyVersions}
            optionLabel={'versions'}
            name="versions"
            optionValue={'versions'}
            onChange={serviceCatalog.handleOnVersionChange}
          />
        </div>
      );
    }
  };

  const renderExportTemplateButton = () => {
    if (serviceCatalog.catalog !== CatalogType.SamTypes) {
      return (
        <ButtonComponent
          label={'Exportar plantilla'}
          className="w-1/4 h-12 bg-white border-solid border border-alternative_green text-alternative_green hover:bg-alternative_green"
          onClick={serviceCatalog.exportTemplateExcel}
        />
      );
    }
    return null;
  };

  const renderExportButton = () => {
    return (
      <ButtonComponent
        label={'Exportar'}
        className="w-1/4 h-12 bg-white border-solid border border-alternative_green text-alternative_green hover:bg-alternative_green"
        onClick={serviceCatalog.exportExcel}
      />
    );
  };

  const renderFiltersAndExports = () => {
    return (
      <div
        className={`flex w-full h-auto relative flex-row gap-2 pb-2 ${
          serviceCatalog.catalog !== CatalogType.SamTypes &&
          serviceCatalog.catalog !== CatalogType.CardMapping
            ? 'justify-between'
            : 'justify-end'
        }`}>
        {validatePermissions(PermitsList.CATALOGS_IMPORT) &&
          serviceCatalog.catalog !== CatalogType.SamTypes &&
          serviceCatalog.catalog !== CatalogType.CardMapping && (
            <form
              className="flex w-full h-full gap-4"
              onSubmit={serviceCatalog.handleSubmitExcel}>
              <input
                id="file"
                name="file"
                type="file"
                className="w-auto h-12 absolute opacity-0 cursor-pointer invisible !bg-white !border-solid border border-alternative_green text-alternative_green hover:bg-alternative_green"
                onChange={serviceCatalog.handleFileChange}
              />
              {renderFileUploadLabel()}
              {renderImportButton()}
            </form>
          )}

        {validatePermissions(PermitsList.CATALOGS_EXPORT) &&
          serviceCatalog.catalog !== CatalogType.CardMapping && (
            <>
              {renderFilters()}
              {renderExportTemplateButton()}
              {renderExportButton()}
            </>
          )}
      </div>
    );
  };

  /**
   * Regresa la columa de acciones, icono de edicion y eliminacion de cada item
   * @param row El resgistro que se selecciono en la tabla
   */
  const renderEditIcon = (row: any) => {
    if (validatePermissions(PermitsList.CATALOGS_EDIT)) {
      return (
        <LuFileEdit
          className="cursor-pointer text-official_green"
          onClick={() => serviceCatalog.openTableRightMenu(row)}
        />
      );
    }
    return null;
  };

  const renderDeleteIcon = (row: any) => {
    const canDelete = !(
      serviceCatalog.catalog === 'Tipos de dispositivo' &&
      row?.enumType !== undefined &&
      row?.enumType !== null &&
      row?.enumType <= 8
    );

    if (validatePermissions(PermitsList.CATALOGS_DELETE) && canDelete) {
      return (
        <LuTrash2
          className="cursor-pointer text-red"
          onClick={() => serviceCatalog.openDeleteModal(row)}
        />
      );
    }
    return null;
  };

  const renderShowMappingsBySam = (row: any) => {
    return (
      <div className="flex w-full justify-around text-xl">
        <LuEye
          className="cursor-pointer text-official_green"
          onClick={() => serviceCatalog.openMeppingDetailModal(row)}
        />
      </div>
    );
  };

  const actionsRow = (row: any) => {
    return (
      <div className="flex w-full justify-around text-xl">
        {renderEditIcon(row)}
        {renderDeleteIcon(row)}
      </div>
    );
  };

  const BodyTemplate = (item: any, key: any) => {
    let textColor = item[key.field];

    if (typeof item[key.field] === 'boolean') {
      return tableBooleanValue(textColor);
    }

    if (
      key.field === 'id' &&
      item['samTypeName'] === null &&
      item['transportCompanyName'] === null
    )
      return labelTemplate(textColor);
    return textColor;
  };

  const tableBooleanValue = (text: boolean) => {
    return <span>{text ? 'Activo' : 'Inactivo'}</span>;
  };

  const labelTemplate = (text: any) => {
    return (
      <span
        className="!font-bold !text-[#f59e0b]"
        title="Advertencia: Se necesita completar los datos correspondientes">
        {text}
      </span>
    );
  };

  const generateColumns = () => {
    let listColumn = serviceCatalog.columns.map((column: any, index: any) => {
      const key = index.toString();
      return (
        <Column
          key={key}
          field={column.field}
          header={column.header}
          bodyClassName="!text-grey !text-[12px]"
          headerClassName="!font-bold !justify-between !bg-white !text-grey"
          filterHeaderClassName="!text-black !justify-between !bg-white !h-8"
          style={{
            flexGrow: 1,
            flexBasis: '100px',
          }}
          sortable={column.sortable}
          filterMenuStyle={{ maxWidth: '100px' }}
          // filterElement={column.filterElement}
          filter={column.filter}
          filterPlaceholder="Buscar"
          showFilterMenu={false}
          body={BodyTemplate}
          filterElement={(options: any) => (
            <InputText
              value={options.value}
              onChange={e => options.filterApplyCallback(e.target.value)}
              placeholder={`${column.header}`}
              className="p-inputtext-sm w-full !h-8 text-sm"
            />
          )}
        />
      );
    });
    if (
      serviceCatalog.catalog !== CatalogType.SamTypes &&
      serviceCatalog.catalog !== CatalogType.CardMapping
    ) {
      listColumn.push(
        <Column
          key={serviceCatalog.columns.length + 1}
          header={'Acciones'}
          bodyClassName="!text-grey !text-[12px]"
          headerClassName="!font-bold !justify-between !bg-white !text-grey"
          filterHeaderClassName="!text-black !justify-between !bg-white !h-8"
          body={actionsRow}
        />
      );
    } else if (
      serviceCatalog.catalog === CatalogType.SamTypes ||
      serviceCatalog.catalog === CatalogType.CardMapping
    ) {
      listColumn.push(
        <Column
          key={serviceCatalog.columns.length + 1}
          header={'Ver mapeo'}
          body={renderShowMappingsBySam}
          bodyClassName="!text-grey !text-[12px]"
          headerClassName="!font-bold !justify-between !bg-white !text-grey"
          filterHeaderClassName="!text-black !justify-between !bg-white !h-8"
        />
      );
    }
    return listColumn;
  };

  const renderContent = () => {
    return (
      <div className="flex w-full h-full relative flex-col gap-y-2">
        <div className="flex flex-col  w-full h-32 bg-white rounded-b-lg shadow-lg p-4">
          {renderTitle()}
          {renderFiltersAndExports()}
        </div>
        <div className="h-full flex flex-col w-full overflow-y-auto relative bg-white rounded-md shadow-lg p-4">
          <TableComponent
            value={serviceCatalog.dataCatalogTable}
            sortField="name"
            responsiveLayout="scroll"
            globalFilterFields={[]}
            resizableColumns
            setSort={serviceCatalog.setSort}
            sort={serviceCatalog.sort}
            filterDisplay="row"
            filters={serviceCatalog.filters}>
            {generateColumns()}
          </TableComponent>
        </div>
      </div>
    );
  };

  return (
    <>
      {serviceCatalog.catalog !== CatalogType.InitMenu ? (
        renderContent()
      ) : (
        <span className="text-3xl">Seleccione un catálogo</span>
      )}
    </>
  );
};
